import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { CultureStateAggData } from 'src/app/moov-common/services/data/data-data';

@Component({
  selector: 'app-culture-card-list',
  templateUrl: './culture-card-list.component.html',
  styleUrl: './culture-card-list.component.scss',
})
export class CultureCardListComponent extends BaseComponent {
  @Input() sortedFamiliesAggData: CultureStateAggData[] | undefined = [];
  @Input() selectedCultureId: string = '';
  @Input() isLoading: boolean = true;
  @Output() onCultureSelected = new EventEmitter<string>();

  constructor() {
    super();
  }

  onCultureSelectedHandler(cultureId: string) {
    this.onCultureSelected.emit(cultureId);
  }
}
